<template>
  <div class="page-wrapper" id="app">
    <div class="content">
      <header class="header">
        <a class="logo logo--mediasoft" target="_blank" href="https://mediasoft.team/">
          <img :src="logoOne" alt="" title="" />
        </a>
        <a class="logo" target="_blank" href="https://tagline.ru/">
          <img :src="logoTwo" alt="" title="" />
        </a>
      </header>
      <h1 class="title">DIGITAL-тотализатор</h1>
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
      <div class="dot">
        <router-link class="dot__item" :to="{name: 'index'}" exact></router-link>
        <router-link class="dot__item" :to="{name: 'statistics'}"></router-link>
        <router-link class="dot__item" :to="{name: 'rating'}"></router-link>
      </div>
    </div>
  </div>
</template>

<script>
import logoOne from './assets/img/logo-mediasoft.png';
import logoTwo from './assets/img/logo-tagline.png';

export default {
  data() {
    return {
      logoOne,
      logoTwo,
    };
  },
};
</script>
<style lang="less">
@import './assets/style/reset.less';
@import './assets/style/global.less';
.dot {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 4rem;
  left: 50%;
  transform: translateX(-50%);
  &__item {
    border-radius: 100%;
    background-color: red;
    margin-right: 1rem;
    width: 1.3rem;
    height: 1.3rem;
    background-color: #707070;
    transition: 0.3s;
    &:last-child {
      margin-right: 0;
    }
    &.router-link-active {
      background-color: #f0f0f0;
    }
  }
}
</style>
